<template>
  <tr>
    <td
    v-for="(total, index) in displayArray"
    :key="index"
    :colspan="`${total.colspan ? total.colspan : '1'}`">
      <div
      v-if="total.value !== undefined"
      class="is-pulled-right">
        {{formatage(total.value)}}
      </div>
    </td>
  </tr>
</template>

<script>
import calculArrondi from '@/services/calcul/calculArrondi';
import { formatDevise } from '@/services/general/filters/formatDevise';
import get from 'lodash/get';

export default {
  props: {
    columns: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    target: {
      type: Array,
      required: true,
    },
    formatage: {
      type: Function,
      required: false,
      default: (value) => formatDevise(value),
    },
  },
  data() {
    return {
      formatDevise,
    };
  },
  computed: {
    totauxWithIndex() {
      const totaux = this.target.map(columnName => {
        const t = {
          column: columnName,
          value: this.getTotal(columnName),
        };
        const position = this.columnsWithChild.findIndex(c => c === columnName);
        if (position >= 0) {
          t.position = position;
        }
        return t;
      })
        .sort((a, b) => a.position - b.position);
      return totaux;
    },
    displayArray() {
      const display = [];
      this.totauxWithIndex.forEach((t, index, array) => {
        if (index === 0) {
          if (t.position !== 0) {
            display.push({ colspan: t.position });
          }
        } else {
          const diffposi = t.position - (array[index - 1].position + 1);
          if (diffposi > 0) {
            display.push({ colspan: diffposi });
          }
        }
        display.push(t);
        if (index === array.length - 1) {
          if (this.columnsWithChild.length - 1 !== t.position) {
            display.push({ colspan: this.columnsWithChild.length - 1 - t.position });
          }
        }
      });
      return display;
    },
    hasChildRow() {
      return !!this.$parent.opts().childRow || !!this.$parent.scopedSlots()?.child_row;
    },
    columnsWithChild() {
      return this.hasChildRow ? ['child', ...this.columns] : this.columns;
    },
  },
  methods: {
    getTotal(field) {
      return calculArrondi(this.items.reduce((a, b) => a + this.check(get(b, field)), 0));
    },
    check(input) {
      if (typeof input !== 'number') return 0;
      return input;
    },
  },
};
</script>

<style>

</style>
